
export default {
  props: ['src', 'rest']
}
